
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { PostItemProps } from ".";
import { loading, create } from "store/post";

interface ApiPostCreateInputProps extends Omit<PostItemProps, "id"> {
}

type ApiPostCreateOutputProps = OutputBaseProps<{ item: PostItemProps; }, ApiPostCreateInputProps>

export const apiPostCreate = async (data: ApiPostCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiPostCreateOutputProps>("/api/post/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
    }
    return res;
};